import React, { useState, useEffect } from 'react';
import Barcode from 'react-barcode';
import formatters from '../../../Core/Grid/inputFormatter';
import { TextBox } from '../../../Core/FormInput';

class BarcodeErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        console.error('Barcode rendering error:', error);
    }

    render() {
        if (this.state.hasError) {
            return <div style={{ padding: '20px', color: '#d32f2f' }}>Invalid barcode value</div>;
        }
        return this.props.children;
    }
}

export default function ShowBarCode(props) {
    const [barcodeValue, setBarcodeValue] = useState(() => {
        return props?.wipNo
            ? props?.wipNo
            : // formatters.addPrefixAndSuffixToBarCode(props?.wipNo)
              '';
    });

    useEffect(() => {
        if (props?.wipNo) {
            setBarcodeValue(props?.wipNo);
        }
    }, [props?.wipNo]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '16px 24px', width: '100%', boxSizing: 'border-box' }}>
            <div style={{ width: '100%', maxWidth: '360px', marginBottom: '16px' }}>
                <TextBox label="Barcode Value" value={barcodeValue} onChange={(e) => setBarcodeValue(e.target.value)} placeholder="Enter barcode value" />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '140px' }}>
                {barcodeValue ? (
                    <BarcodeErrorBoundary key={barcodeValue}>
                        <Barcode value={barcodeValue} />
                    </BarcodeErrorBoundary>
                ) : (
                    <div style={{ padding: '20px', color: '#666' }}>No barcode value available</div>
                )}
            </div>
        </div>
    );
}
